export default __webpack_public_path__ + "static/media/domki11.bd9dda0d.jpg";